import { MandateStatus } from "../context/MandateStatusContext";
import { ProfileStatusSlug } from "../context/ProfileStatusContext";

export const SIDEBAR_WIDTH = 72;
/** Matches SIDEBAR_WIDTH so the top bar and the sidebar's logo tile form a square corner. */
export const TOPBAR_HEIGHT = SIDEBAR_WIDTH;

export const MandateStatusColours: { [key in MandateStatus]: string } = {
  [MandateStatus.New]: "gray.60",
  [MandateStatus.InProgress]: "blue.primary",
  [MandateStatus.InReview]: "orange.50",
  [MandateStatus.Completed]: "green.primary",
  [MandateStatus.Rejected]: "red.primary",
};

export const ProfileStatusColours: Record<ProfileStatusSlug, string> = {
  [ProfileStatusSlug.New]: "gray.60",
  [ProfileStatusSlug.InProgress]: "blue.primary",

  [ProfileStatusSlug.RequiresReview]: "orange.50",
  [ProfileStatusSlug.SecondaryReview]: "orange.50",
  [ProfileStatusSlug.PeriodicReview]: "orange.50",

  [ProfileStatusSlug.Completed]: "green.primary",
  [ProfileStatusSlug.Rejected]: "red.primary",
};

export const ProfileStatusBgColours: Record<ProfileStatusSlug, string> = {
  [ProfileStatusSlug.New]: "gray.10",
  [ProfileStatusSlug.InProgress]: "blue.10",

  [ProfileStatusSlug.RequiresReview]: "orange.primary",
  [ProfileStatusSlug.SecondaryReview]: "orange.primary",
  [ProfileStatusSlug.PeriodicReview]: "orange.primary",

  [ProfileStatusSlug.Completed]: "green.50",

  [ProfileStatusSlug.Rejected]: "red.50",
};
